exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "button.plant-settings-button > span.icon-settings {\n  font-size: 32px;\n  color: rgb(70, 70, 70);\n  border: 2px solid rgb(70, 70, 70);\n  border-radius: 100%;\n  padding: 4px;\n  background-color: white;\n}\n\nbutton.plant-settings-button:hover > span.icon-settings {\n  background-color: rgb(209, 209, 209);\n}\n", ""]);

// exports
